/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_SubtitleInputs */

const cs_settings_users_subtitle = /** @type {(inputs: Settings_Users_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účty a role. Makléři inzerují na Sreality jako selleri pod firemním RK — nedostávají vlastní importní heslo.`)
};

const en_settings_users_subtitle = /** @type {(inputs: Settings_Users_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts and roles. Brokers publish on Sreality as sellers under the office RK — they do not get their own import password.`)
};

/**
* | output |
* | --- |
* | "Accounts and roles. Brokers publish on Sreality as sellers under the office RK — they do not get their own import password." |
*
* @param {Settings_Users_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_subtitle = /** @type {((inputs?: Settings_Users_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_subtitle(inputs)
	return cs_settings_users_subtitle(inputs)
});